const routes = {
  home: process.env.REACT_APP_WEB_URL,
  termsOfService: `${process.env.REACT_APP_WEB_URL}/terms-of-use/`,
  privacyPolicy: `${process.env.REACT_APP_WEB_URL}/privacy-policy/`,
  employerHome: process.env.REACT_APP_EMPLOYER_URL,
  employerLogin: `${process.env.REACT_APP_EMPLOYER_URL}/login/`,
  employerRegister: `${process.env.REACT_APP_EMPLOYER_URL}/register/`,
  employerContactUs: `${process.env.REACT_APP_EMPLOYER_URL}/contact-us/`,
  employerPostJob: `${process.env.REACT_APP_EMPLOYER_URL}/post-job/`,
  employerSearchCandidate: `${process.env.REACT_APP_EMPLOYER_URL}/search-candidate/`,
  login: '/login/',
  register: '/jobseeker-signup/',
  authGateWay: '/auth/:action',
  parseResume: '/profile/onboard',
  registerOtpVerify: '/register-otp-verify/',
  forgotPassword: '/forgot-password/',
  resetPassword: '/reset-password/',
  dashboard: '/dashboard/',
  about: `${process.env.REACT_APP_WEB_URL}/about-us/`,
  jobs: `${process.env.REACT_APP_WEB_URL}/jobs/`,
  blog: `${process.env.REACT_APP_WEB_URL}/blog/`,
  searchJob: '/search-job',
  appliedJob: '/applied-job/',
  views: '/views',
  savedJob: '/saved-job/',
  jobDetails: '/job',
  jobAlert: '/job-alert/',
  jobAlertAdd: '/job-alert/add',
  profile: '/profile/',
  settings: '/settings',
  changePassword: '/settings/change-password/',
  blocking: '/settings/blocking/',
  subscription: '/settings/subscription/',
  viewMessages: '/view-messages/',
  contact: '/contact-us/',
  thankYou: '/thank-you/',
  accountVerify: '/account-verify',
  interviewResponse: '/interview-response',
  verifyEmailChange: '/verify-email-change',
  notFound: '/404/',
  notApplicable: '-',
  getIp: `${process.env.REACT_APP_API_URL}/v2/get_ip_details`,
  commanFooter: {
    contact: `${process.env.REACT_APP_WEB_URL}/contact-us/`
  }
};

export default routes;
